import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitDeleteDealflow } from 'components/views/InvestorDealflow/_helpers/investorDealflow.events';
import { $form, $view } from 'signals/global.signals';

const InvestorDeleteDealflowModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'investor-dealflow-delete'}
    title="Delete Opportunity"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDeleteDealflow}
    primaryButtonColor="danger"
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <p>Are you sure you want to remove <b className="text-warning">{$form.value.name}</b> from your pipeline? <br /><small className="text-gray-300">Note: This will NOT remove them from your account.</small></p>
  </SimpleModal>
);

export default InvestorDeleteDealflowModal;
